import React, { Component, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import Button from './Buttons'
import AddIcon from '@material-ui/icons/Add'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core'
import SuccessIcon from '@material-ui/icons/Check'
import WaitingIcon from '@material-ui/icons/AccessTime'
import LinearProgress from '@material-ui/core/LinearProgress'
import { actions } from './SearchServicesTableReducer'
import { connect } from 'react-redux'
import { DisconnectedIcon } from 'common/components/icons'
import { ConnectedIcon } from 'common/components/icons'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const deviceStatStyle = {
    icon: {
        display: 'inline',
        height: '23px',
    },
    successIcon: {
        extend: 'icon',
        fill: '#0088CF',
    },

    // '@keyframes breathe': {
    //     from: { opacity: 0.2 },
    //     to: { transform: 1.0 }
    // },

    errorIcon: {
        extend: 'icon',
        fill: '#C03A2B',
        marginTop: '3px',
        
        // animationName: 'breathe',
        // animationDuration: '1.0s',
        // animationIterationCount: 'infinite',
        // animationDirection: 'alternate',
    },
    value: {
        // display: 'inline',
        marginLeft: '4px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '9em',
        "&:hover": {
            overflow: 'initial',
            background: "#efefef"
        },  
    }
}


const _DeviceStatus = ({ classes, value }) => {
    // waiting - neutral
    // success - good
    // rest - bad
    switch (value) {
        case 'success':
            return <Grid container alignItems='center'>
                <Grid item>
                    <SuccessIcon className={classes.successIcon} />
                </Grid>
                <Grid item>
                    <Typography variant='overline' className={classes.value}>
                        {value}
                    </Typography>
                </Grid>
            </Grid>

        case 'waiting':
            return <Grid container alignItems='center'>
                <Grid item>
                    <WaitingIcon className={classes.successIcon} />
                </Grid>
                <Grid item>
                    <Typography variant='overline' className={classes.value}>
                        {value}
                    </Typography>
                </Grid>
            </Grid>
        case 'Disconnected':
            return <Grid container alignItems='center'>
                <Grid item>
                    <DisconnectedIcon className={classes.successIcon} />
                </Grid>
                <Grid item>
                    <Typography variant='overline' className={classes.value}>
                        {value}
                    </Typography>
                </Grid>
            </Grid>
        case 'Connected':
            return <Grid container alignItems='center'>
                <Grid item>
                    <ConnectedIcon color='#0088CF' className={classes.successIcon} />
                </Grid>
                <Grid item>
                    <Typography variant='overline' className={classes.value}>
                        {value}
                    </Typography>
                </Grid>
            </Grid>
        default:
            return <Grid container alignItems='center'>
                <Grid item>
                    <ErrorOutlineIcon className={classes.errorIcon} />
                </Grid>
                <Grid item>
                    <Typography variant='overline' className={classes.value}>
                        {value || "N/A"}
                    </Typography>
                </Grid>
            </Grid>

    }
}

const DeviceStatus = withStyles(deviceStatStyle)(_DeviceStatus);

const hashStatusStyles = {
    value: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '9em',
        "&:hover": {
            overflow: 'initial',
            background: "#efefef"
        },  
    },
    icon: {
        display: 'inline',
        height: '23px',
    },
    successIcon: {
        extend: 'icon',
        fill: '#0088CF',
    },
    errorIcon: {
        extend: 'icon',
        fill: '#C03A2B',
        // marginTop: '4px',
        marginRight: '3px',
    },
    expandIconNormal:{
        transform: 'rotate(-90deg)',
        width: '20x',
        marginLeft: '-20px',
        fill:'#757575',
        
    },
    expandIconExpanded:{
        extend: 'expandIconNormal',
        transform: 'rotate(0deg)',
    },
    container:{
        cursor:'pointer'
    }
}
const _HashStatus = ({
    classes,
    name,
    desired,
    reported
}) => {
    const [expanded, setExpanded] = useState(false);
    return <Grid container item xs={12} alignItems="center" onClick={() => setExpanded(!expanded)} className={classes.container}>
        <Grid item xs={5} container alignItems='center'>
            <ExpandMoreIcon className={expanded ? classes.expandIconExpanded : classes.expandIconNormal}/>
            {name}:
                </Grid>
        <Grid item container xs={7}>
            {
                desired !== reported ? <Grid container item xs={12} alignItems='center'>
                    <Grid item>
                        <ErrorOutlineIcon color='#0088CF' className={classes.errorIcon} />
                    </Grid>
                    <Grid item>
                        <Typography variant='caption' color='textSecondary'>
                            <div className={classes.value}>
                                {reported || 'N/A'}
                            </div>
                        </Typography>
                    </Grid>
                </Grid> :
                    <Grid container item xs={12} alignItems='center'>
                        <Grid item>
                            {
                                reported === null ? <ErrorOutlineIcon className={classes.errorIcon} /> :
                                <SuccessIcon className={classes.successIcon} />
                            }
                            
                        </Grid>
                        <Grid item>
                            <Typography variant='caption' color='textSecondary'>
                                <div className={classes.value}>
                                    {reported || 'N/A'}
                                </div>
                            </Typography>
                        </Grid>
                    </Grid>
            }
        </Grid>
        <Grid item xs={12} onClick={(event)=>{
            event.stopPropagation();
            event.preventDefault()}
            }>
            <Collapse in={expanded}>
                <Grid container>
                    <Grid item xs={5} style={{ paddingLeft: '13px', fontWeight: '300' }}>
                        Desired:
                            </Grid>
                    <Grid item xs={7}>
                        <Typography variant='caption' color='textSecondary'>
                            <div className={classes.value}>
                                {desired || 'N/A'}
                            </div>
                        </Typography>
                    </Grid>
                    <Grid item xs={5} style={{ paddingLeft: '13px', fontWeight: '300' }}>
                        Reported:
                            </Grid>
                    <Grid item xs={7}>
                        <Typography variant='caption' color='textSecondary'>
                            <div className={classes.value}>
                                {reported || 'N/A'}
                            </div>
                        </Typography>
                    </Grid>
                </Grid>
            </Collapse>
        </Grid>
    </Grid>
}

const HashStatus = withStyles(hashStatusStyles)(_HashStatus);


const styles = {
    value: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth:'200px',

        "&:hover": {
            overflow: 'initial',
            background: "#efefef"
        },
    },
    lastUpdatedRow:{
        marginTop:'4px',
    },
    lastUpdatedDiv:{
        extend:'value',
        overflow:'unset',
    }
}
const DeviceInfo = ({
    classes,
    device,
    openTunnel,
    tunnelOpening = false,
    tunnelResult,
    ping,
    pinging,
    pingResult,
}) => {
    // const lastUpdated = moment(device.last_updated);
    // if(moment().diff(lastUpdated, 'days') > 0)
    //     delta = moment().diff(lastUpdated, 'days')
    // if(delta < 1){
    //     delta.toString();
    // }


    return <Grid container item xs={12} alignItems='center'>
        <Grid container item xs={12} alignItems='center'>
            <Grid item xs={5}>
                Config Status:
        </Grid>
            <Grid item xs={7}>
                <Typography variant='caption' color='textSecondary'>
                    <div className={classes.value}>
                        <DeviceStatus value={device.status} />
                    </div>
                </Typography>
            </Grid>
        </Grid>
        <Grid container item xs={12} alignItems='center'><Grid item xs={5}>
            Connection:
        </Grid>
            <Grid item xs={7}>
                <Typography variant='caption' color='textSecondary'>
                    <div className={classes.value}>
                        <DeviceStatus value={device.connection_state} />
                    </div>
                </Typography>
            </Grid>
        </Grid>
        <Grid container item xs={12} alignItems='center'>
            <HashStatus
                name="Cert Hash"
                desired={device.desired_certificate_bundle_hash}
                reported={device.reported_certificate_bundle_hash}
            />
            {/* <Grid item xs={5}>
                Cert Hash:
        </Grid>
            <Grid item xs={7}>
                <Typography variant='caption' color='textSecondary'>
                    <div className={classes.value}>
                        {device.desired_certificate_bundle_hash}
                    </div>
                </Typography>
            </Grid> */}
        </Grid>
        <Grid container item xs={12} alignItems='center'>
            <HashStatus
                name={"Config Hash"}
                desired={device.desired_config_xml_hash}
                reported={device.reported_config_xml_hash}
            />
            {/* Config Hash:
        </Grid>
            <Grid item xs={7}>

                <Typography variant='caption' color='textSecondary'>
                    <div className={classes.value}>
                        {device.desired_config_xml_hash}
                    </div>
                </Typography>

            </Grid> */}
        </Grid>
        <Grid container item xs={12} alignItems='center' className={classes.lastUpdatedRow}><Grid item xs={5}>
            Last Updated:
        </Grid>
            <Grid item xs={7} >
                <Typography variant='caption' color='textSecondary'>
                    <div className={classes.lastUpdatedDiv}>
                        {device.last_updated}
                    </div>
                </Typography>

            </Grid>
        </Grid>
        {
            tunnelOpening ? <Collapse in={true} appear={true} style={{ width: '100%' }}><Grid container item xs={12} alignItems='center'>


                <Grid container item xs={12} alignItems='center'><Grid item xs={5}>
                    Tunnel:
                </Grid>
                    <Grid item xs={7}>

                        <LinearProgress style={{ width: '100%', height: '2px' }} />
                    </Grid>

                </Grid>
            </Grid>
            </Collapse> : tunnelResult ? <React.Fragment>
                <Grid container item xs={12} alignItems='center'><Grid item xs={5}>
                    Tunnel:
                </Grid>
                    <Grid item xs={7}>
                        {tunnelResult === 'FAIL' ? 'Unable To Open' : tunnelResult}
                    </Grid>
                </Grid>
            </React.Fragment> : ''
        }
        {
            pinging ? <Collapse in={true} appear={true} style={{ width: '100%' }}><Grid container item xs={12} alignItems='center'>


                <Grid container item xs={12} alignItems='center'><Grid item xs={5}>
                    Ping:
                </Grid>
                    <Grid item xs={7}>

                        <LinearProgress style={{ width: '100%', height: '2px' }} />
                    </Grid>
                </Grid>
            </Grid></Collapse> : pingResult ? <React.Fragment>
                <Grid container item xs={12} alignItems='center'><Grid item xs={5}>
                    Ping:
                </Grid>
                    <Grid item xs={7}>
                    <Typography variant='caption' color='textSecondary'>
                            <div className={classes.value}>
                                {pingResult === 'FAIL' ? 'ERROR' : pingResult}
                            </div>
                        </Typography>
                           
                    </Grid>
                </Grid>
            </React.Fragment> : ''
        }
        <Grid container item xs={12} style={{ paddingTop: '10px' }}>
            <Button variant='outlined' style={{ width: tunnelOpening ? '90px' : '70px' }} onClick={!tunnelOpening ? () => openTunnel(device['device_id']) : undefined}>
                {
                    tunnelOpening ? <CircularProgress size={10} style={{ marginRight: '6px' }} /> :
                        <AddIcon style={{ display: 'inline', fill: '#0088CF', height: '16px', width: '16px', marginLeft: '-3px' }} />
                }
                {
                    tunnelOpening ? 'OPENING' : 'TUNNEL'
                }

            </Button>
            <Button variant='outlined' style={{ width: pinging ? '70px' : '50px', display: 'inline' }} onClick={!pinging ? () => ping(device['device_id']) : undefined}>
                {
                    pinging && <CircularProgress size={10} style={{ marginRight: '6px' }} />
                }
                {
                    pinging ? 'PINGING' : 'PING'
                }
            </Button>
        </Grid>
        {/* <Grid container item xs={12} >
            {
                tunnelOpening ? 
                    <Grid item xs={12} >
                        <BreathingText>
                        <Typography color='primary' variant='caption' style={{fontWeight:'300 !important'}}>
                            Opening Support Tunnel...
                        </Typography>
                        </BreathingText>
                        <LinearProgress style={{width:'100%', height:'2px'}}/>
                    </Grid>
                 :
                <Grid item xs={12} style={{height:'60'}}>
                    Tunnel: {tunnelResult}
                </Grid>
            }
        </Grid> */}
    </Grid>
}

const DeviceInfoStyled = withStyles(styles)(DeviceInfo)

class DeviceInfoStyledWrapper extends Component {
    render() {
        return (
            <React.Fragment>
                <DeviceInfoStyled {...this.props} />                
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const supportTunnels = state.waas.searchServices.searchServices.supportTunnels
    const deviceId = ownProps.device.device_id
    const supportTunnel = supportTunnels[deviceId]
    const pings = state.waas.searchServices.searchServices.pings
    const ping = pings[deviceId]
    return {
        tunnelResult: supportTunnel ? supportTunnel['result'] : undefined,
        tunnelOpening: supportTunnel ? supportTunnel['loading'] : undefined,
        pingResult: ping ? ping['result'] : undefined,
        pinging: ping ? ping['loading'] : undefined,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        openTunnel: () => dispatch(actions.getSupportTunnel(ownProps.device['device_id'])),
        ping: () => dispatch(actions.getPing(ownProps.device['device_id']))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceInfoStyledWrapper)